export default "__VITE_ASSET__C3f3tqPF__"